import TextEllipsis from './TextEllipsis';

export default TextEllipsis;
